import { BeanBase } from './beanBase.ts';

export class BeanAopBase extends BeanBase {}
